<template>
    <div class="check-line props-group">
        <el-form-item label="可勾选数据行">
           <el-tooltip class="item" effect="dark" content="开启后可通过代码得到被勾选的数据。" placement="bottom-start">
             <span class="fa fa-question-circle"></span>
           </el-tooltip>
          <el-switch v-model="component.properties.checkLine" @change="$emit('update', 'checkLine')"></el-switch>
        </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'attr-check-line',
  props: ['component'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
  .check-line {
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/check-line.vue